import { render } from "./StrongsHome.component.vue?vue&type=template&id=35c60222&scoped=true"
const script = {}

import "./StrongsHome.component.vue?vue&type=style&index=0&id=35c60222&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c60222"]])

export default __exports__